import React from 'react';

const Distribution = () => {
    return (
        <div>Distribution Component</div>
    );
}

export default Distribution;
